<!-- Unauthenticated users -->
@if (!isAuthenticated) {
  <div class="nav-item">
    <a mat-button routerLink="/about" routerLinkActive="active">Why QualityBidders?</a>
  </div>
  <div class="nav-item">
    <a mat-button routerLink="/opportunities" routerLinkActive="active">Opportunities</a>
  </div>
  <div class="nav-item">
    <a mat-button routerLink="/contacts" routerLinkActive="active">Contacts</a>
  </div>
  <div class="nav-item">
    <a mat-button routerLink="/help" routerLinkActive="active">Help</a>
  </div>
}

<!-- Vendor users -->
@if (isVendor) {
  <div class="nav-item">
    <a mat-button routerLink="/vendor" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
  </div>
  <div class="nav-item">
    <a mat-button routerLink="/vendor/applications" routerLinkActive="active">Applications</a>
  </div>
  <div class="nav-item">
    <a mat-button routerLink="/opportunities" routerLinkActive="active">Opportunities</a>
  </div>
  <div class="nav-item">
    <a mat-button routerLink="/contacts" routerLinkActive="active">Contacts</a>
  </div>
}

<!-- Agency users -->
@if (isAgency && !isQbat) {
  <div class="nav-item">
    <a mat-button routerLink="/agency" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
  </div>
  <div class="nav-item">
    <a mat-button routerLink="/agency/applications" routerLinkActive="active">Applications</a>
  </div>
  <div class="nav-item">
    <a mat-button routerLink="/agency/reports" routerLinkActive="active">Reports & Email</a>
  </div>
  <!-- Management dropdown -->
  @if (canAccessFeature('pAgencyAdmin') || canAccessFeature('pUserAdmin') || canAccessFeature('pRoleAdmin')) {
    <div class="nav-item dropdown" routerLinkActive="active">
      <a mat-button type="button" aria-haspopup="true" aria-expanded="false" aria-label="Management">Management</a>
      <div class="nested-dropdown" aria-label="Management">
        @if (canAccessFeature('pAgencyAdmin')) {
          <a class="dropdown-item" routerLink="/agency/admin" routerLinkActive="active">Agency Management</a>
        }
        @if (canAccessFeature('pUserAdmin')) {
          <a class="dropdown-item" routerLink="/agency/users" routerLinkActive="active">User Management</a>
        }
        @if (canAccessFeature('pRoleAdmin')) {
          <a class="dropdown-item" routerLink="/agency/roles" routerLinkActive="active">Role Management</a>
        }
      </div>
    </div>
  }
  <div class="nav-item">
    <a mat-button routerLink="/opportunities" routerLinkActive="active">Opportunities</a>
  </div>
}

<!-- QBAT users -->
@if (isQbat) {
  <div class="nav-item">
    <a mat-button routerLink="/qbat/prequalification" routerLinkActive="active">Prequalification</a>
  </div>
  <div class="nav-item">
    <a mat-button routerLink="/qbat/cupccaa" routerLinkActive="active">CUPCCAA</a>
  </div>
  @if (canAccessFeature('pUserAdmin') || canAccessFeature('pRoleAdmin')) {
    <div class="nav-item dropdown" routerLinkActive="active">
      <a mat-button type="button" aria-haspopup="true" aria-expanded="false" aria-label="Management">Management</a>
      <div class="nested-dropdown" aria-label="Management">
        @if (canAccessFeature('pUserAdmin')) {
          <a class="dropdown-item" routerLink="/qbat/users" routerLinkActive="active">User Management</a>
        }
        @if (canAccessFeature('pRoleAdmin')) {
          <a class="dropdown-item" routerLink="/qbat/roles" routerLinkActive="active">Role Management</a>
        }
      </div>
    </div>
  }
  <div class="nav-item">
    <a mat-button routerLink="/opportunities" routerLinkActive="active">Opportunities</a>
  </div>
}

<!-- Permission-based navigation -->
@if (hasPermission('colbi_admin:view') | async) {
  <div class="nav-item">
    <a mat-button routerLink="/admin" routerLinkActive="active">Colbi Admin</a>
  </div>
}

<!-- Help link for all authenticated users -->
@if (isAuthenticated) {
  <div class="nav-item">
    <a mat-button routerLink="/help" routerLinkActive="active">Help</a>
  </div>
}
